var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVisibilityHide2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.70671 12.879 11.17218-11.17219 1.4142 1.4142-11.17218 11.17218zm.99329-1.679 1.1-1.1a5.06309 5.06309 0 0 1 -2-2.1 7.48271 7.48271 0 0 1 6.2-3.5 4.86864 4.86864 0 0 1 1.2.1l1.3-1.3a10.0745 10.0745 0 0 0 -2.5-.3 8.84128 8.84128 0 0 0 -8 5 8.42453 8.42453 0 0 0 2.7 3.2zm10.7-6.4-1.1 1.1a7.08628 7.08628 0 0 1 2 2.1 7.50321 7.50321 0 0 1 -6.2 3.5 8.31666 8.31666 0 0 1 -1.3-.2l-1.3 1.3a8.909 8.909 0 0 0 6.4-.5 9.04344 9.04344 0 0 0 4.1-4.1 9.16786 9.16786 0 0 0 -2.6-3.2z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVisibilityHide2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/visibility-hide_2.9eda100b2ee10376b75eb8ddd21e6e57.svg";